module.exports = __webpack_public_path__ + "img/v3-prism.57c4d582.svg";